import { useInsuranceApiClient } from '@/libs/api/insurance/insurance-client.ts'
import { useConnectDataAttributes } from '@/libs/api/connect/connect.composables.ts'
import { language } from '@/i18n/i18n.ts'
import type { SupportedLocales } from '@/ts/types/locale.types'

export const useInsuranceApiClientImpl = () => {
  const dataAttributes = useConnectDataAttributes()
  const locale = dataAttributes.locale
  const client = useInsuranceApiClient((locale as SupportedLocales) ?? 'de-DE', {
    overwriteTokenKey: `insurance_access_token-${dataAttributes.partnerId}-${language(locale ?? 'de')}`
  })

  return {
    ...client
  }
}
